import React, {useState} from "react";

import PropTypes from 'prop-types';
import { Container,Row,Col, Card, Table,Tab,Tabs, Badge } from "react-bootstrap";
import Image, { propTypes } from "react-bootstrap/Image";


const AdminDashboardMonthViewComponent = props => {
    /** This const would be pulled from DB */
    const openDays =["Friday","Saturday","Sunday"];

    return(
<>
    {/** NOTE -- TO HIDE SCROLL BAR WE NEED TO DIFFERENTIATE BETWEEN BROWSER TYPE */}

    <Card style={{backgroundColor:'#d1d1ca',height:'75vh', backgroundColor:'#d1d1ca', overflowY:'auto', scrollbarWidth:'none'}}>
        <Card.Header style={{color:'#4e6437', fontWeight:'bolder'}} >
            Week {props.week}
        </Card.Header>
        <Card.Body>
            {openDays.map(function (day){
                return(
                    <>
                    <Card style={{backgroundColor:'#c1b1b3', fontWeight:'bolder'}}>
                        <Card.Header>
                            {day}
                        </Card.Header>
                        <Card.Body>
                            Body
                        </Card.Body>
                    </Card> 
                    <br></br>
                    </>
                )
            })}
        </Card.Body>
        
    </Card>

</>
    );

}

AdminDashboardMonthViewComponent.defaultProps ={

}
AdminDashboardMonthViewComponent.propTypes ={
    week: propTypes.string,
}

export default(AdminDashboardMonthViewComponent);